// 공정 표준 화면 주소 — 탭은 경로, Q&A 주제·제안 상태 거르기는 쿼리(손으로 고친 값은 아는 것만 받는다).

import type { ProposalView } from "@buildpy/core/modules/process-standard/proposal/types";
import { QNA_TOPICS, type QnaTopic } from "@buildpy/core/modules/process-standard/qna/types";
import type { StatusTone } from "@buildpy/ui/status-badge";

export const STANDARDS_PATH = "/app/standards";

export const STANDARDS_TABS = [
  { key: "items", label: "공정 표준" },
  { key: "proposals", label: "숫자 제안" },
  { key: "qna", label: "Q&A" },
] as const;

export type StandardsTab = (typeof STANDARDS_TABS)[number]["key"];

export const toQnaTopic = (value: string | undefined): QnaTopic => QNA_TOPICS.find((t) => t === value) ?? "METHOD";

// 제안 단계 — 검토 중인데 마감이 지났으면 「마감」(운영자 결정 대기).
export const PROPOSAL_PHASES = ["reviewing", "closed", "approved", "rejected"] as const;
export type ProposalPhase = (typeof PROPOSAL_PHASES)[number];

export const PROPOSAL_PHASE_LABEL: Record<ProposalPhase, string> = { reviewing: "검토 중", closed: "마감", approved: "승인", rejected: "반려" };

export const PROPOSAL_PHASE_TONE: Record<ProposalPhase, StatusTone> = { reviewing: "progress", closed: "hold", approved: "done", rejected: "dropped" };

export const proposalPhase = (p: Pick<ProposalView, "status" | "review_open">): ProposalPhase => {
  if (p.status === "reviewing") return p.review_open ? "reviewing" : "closed";
  return p.status;
};

export const toProposalPhase = (value: string | undefined): ProposalPhase | null => PROPOSAL_PHASES.find((p) => p === value) ?? null;

export const filterProposals = <T extends Pick<ProposalView, "status" | "review_open">>(list: readonly T[], phase: ProposalPhase | null): T[] =>
  phase ? list.filter((p) => proposalPhase(p) === phase) : [...list];

// 찬반을 남길 수 있나 — 검토 중 · 다른 회사 제안 · 아직 안 남김(최종 판정은 RPC).
export const canVote = (p: Pick<ProposalView, "review_open" | "is_mine" | "my_vote">): boolean => p.review_open && !p.is_mine && p.my_vote === null;

export const tabHref = (tab: StandardsTab): string => (tab === "items" ? STANDARDS_PATH : `${STANDARDS_PATH}/${tab}`);

export const proposalsHref = (phase: ProposalPhase | null): string => (phase ? `${tabHref("proposals")}?status=${phase}` : tabHref("proposals"));

export const proposalHref = (id: string): string => `${tabHref("proposals")}/${encodeURIComponent(id)}`;

export const topicHref = (topic: QnaTopic): string => `${tabHref("qna")}?topic=${topic}`;

export const questionHref = (id: string): string => `${tabHref("qna")}/${encodeURIComponent(id)}`;
